<template>
  <q-dialog :visible="isVisible" :title="title" width="700px" :innerScroll="false" :showFooter="false" @close="onCancel">
    <el-form ref="searchForm" :model="searchForm" :rules="rules" size="mini">
      <div class="header">
        <div>
          <el-form-item label="报告名称:" prop="fileName">
            <el-input v-model="searchForm.fileName"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
        </div>
      </div>
    </el-form>
    <el-table
      :data="tableData.records"
      :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      style="width: 100%"
      height="300"
      ref="table"
      border
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column :show-overflow-tooltip="true" prop="fileName" label="文件名" min-width="200"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="optTypeName" label="操作类型" min-width="100"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="createdByName" label="操作人" width="80"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="createdDate" label="操作时间" width="160"></el-table-column>
    </el-table>
    <div class="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableData.pageNum"
        :page-sizes="[30, 60, 90]"
        :page-size="tableData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total"
      >
      </el-pagination>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '操作日志';
    },
    name() {
      return this.$store.state.user.name;
    },
    isAll() {
      return this.searchForm.type == 1;
    },
  },
  data() {
    return {
      loading: false,
      searchForm: {
        fileName: '',
      },
      rules: {},
      tableData: {
        records: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      visibleColumns: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onSearch() {
      this.tableData.pagNum = 1;
      this.init();
    },
    onReset() {
      this.searchForm.fileName = '';
      this.onSearch();
    },
    async init() {
      this.loading = true
      let data = {
        filterData: {
          ...this.searchForm,
          taskType: 1
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      }
      this.$q.product.fileOptLogListPage({ data: data }).then(({data}) =>{
        this.tableData = data
      }).finally(_=>{
        this.loading = false
      })
    },

    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex
  height: 40px
  align-items: center
  justify-content: space-between
  padding-bottom: 10px
}

.footer {
  text-align: right
  margin-top: 10px
}

>>> .el-form-item--mini{
  width: 280px;
  margin-bottom: 0
}

>>> .el-dialog {
  margin-top: 50px !important
}
</style>
